module.exports = __webpack_public_path__ + "img/bottombag.7e8462bc.jpg";